import { Menu } from './menu';
import { ProductCategory } from './product-category';
import { Product } from './product';
import { ProductSize } from './product-size';
import { ProductCustomizationType } from './product-customization-type';
import { ProductCustomization } from './product-customization';

export class MenuModel {
    brand_id: number;
    outlet_id: number;
    menu_id: number;
    active: boolean;
    open: boolean;
    product_categories: { [key: string]: ProductCategory };
    products: { [key: string]: Product }
    product_sizes: { [key: string]: ProductSize };
    product_customization_types: { [key: string]: ProductCustomizationType };
    product_customizations: { [key: string]: ProductCustomization };
    menu: Menu;
    ct_groups: any;
    product_t_config: any;
    max_total_quantity: number;
    outlet_state: string;
}
